import { render } from "./myqiandaoDesc.vue?vue&type=template&id=bef2e7e4&scoped=true"
import script from "./myqiandaoDesc.vue?vue&type=script&lang=js"
export * from "./myqiandaoDesc.vue?vue&type=script&lang=js"

import "./myqiandaoDesc.vue?vue&type=style&index=0&id=bef2e7e4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bef2e7e4"]])

export default __exports__